import { UPDATE_DUE_DILIGENCE } from '@common/constants/webSockets'
import { IAlias } from '@common/interfaces/bbc'
import { IClientInfo } from '@common/interfaces/client'
import { ICommentary, IDefaultCommentarySection } from '@common/interfaces/commentary'
import {
  IDueDiligenceStats,
  IDueDiligenceAggregation,
  IDueDiligence,
  IDueDiligenceReporting,
  IDueDiligenceDocumentRequest,
  IDueDiligenceDocumentRequestComment,
  IDueDiligenceCompanyInfo,
  IDueDiligenceContact,
  IDueDiligenceReference,
  IDueDiligenceBoardMember,
  IDueDiligenceExecutive,
  IDueDiligenceInventoryLocation,
  IDueDiligenceBankAccount,
  IDueDiligenceDocumentRequestType,
  IDueDiligenceReportingFlowsResponse,
  IHistoricalLineTurnData,
  IHistoricalLineTurnOptionsData,
  IDefaultNote,
  IDefaultNoteOptionsData,
  IDueDiligenceDataRoomFolder,
} from '@common/interfaces/dueDiligence'
import { combineReducers } from 'redux'
import { loadingArrayReducer } from '../../helpers/helpers'
import { createLoadingDataReducer } from '../../helpers/redux'
import { IAction } from '../apiMiddleware'
import { ILoadingData } from '../types'
import * as actions from './actions'

export default combineReducers({
  loadingArray: loadingArrayReducer(
    [actions.prefix],
    [
      actions.SHOW_REPORTING_REQUEST,
      actions.UPDATE_REPORTING_REQUEST,
      actions.SHOW_DOCUMENTS_REQUEST,
      actions.UPDATE_DOCUMENT_REQUEST,
      actions.UNPROCESS_DOCUMENT_REQUEST,
      actions.PROCESS_DOCUMENTS_REQUEST,
      actions.UPLOAD_DOCUMENTS_REQUEST,
      actions.SHOW_DOCUMENT_REQUESTS_TYPES_REQUEST,
      actions.HIDE_TEAM_CONTACTS,
      actions.SHOW_DOCUMENT_REQUESTS_REQUEST,
      actions.HIDE_DOCUMENT_REQUESTS,
      actions.GET_DOCUMENT_REQUESTS_SHARED_LINK_REQUEST,
      actions.UPLOAD_DOCUMENT_REQUESTS_REQUEST,
      actions.CREATE_DOCUMENT_REQUESTS_REQUEST,
      actions.UPDATE_DOCUMENT_REQUESTS_REQUEST,
      actions.UPDATE_DOCUMENTS_REQUESTS_REQUEST,
      actions.DELETE_DOCUMENT_REQUESTS_REQUEST,
      actions.DELETE_DOCUMENTS_REQUESTS_REQUEST,
      actions.CREATE_DOCUMENT_REQUESTS_COMMENT_REQUEST,
      actions.UPDATE_DOCUMENT_REQUESTS_COMMENT_REQUEST,
      actions.DELETE_DOCUMENT_REQUESTS_COMMENT_REQUEST,
      actions.COMPANY_INFO_SUCCESS,
      actions.UPDATE_COMPANY_INFO_SUCCESS,
      actions.LIST_TEAM_CONTACTS_REQUEST,
      actions.HIDE_TEAM_CONTACTS,
      actions.ADD_TEAM_CONTACT_REQUEST,
      actions.UPDATE_TEAM_CONTACT_REQUEST,
      actions.DELETE_TEAM_CONTACT_REQUEST,
      actions.LIST_TEAM_EXECUTIVES_REQUEST,
      actions.HIDE_TEAM_EXECUTIVES,
      actions.ADD_TEAM_EXECUTIVE_REQUEST,
      actions.UPDATE_TEAM_EXECUTIVE_REQUEST,
      actions.DELETE_TEAM_EXECUTIVE_REQUEST,
      actions.LIST_TEAM_BOARD_MEMBERS_REQUEST,
      actions.HIDE_TEAM_BOARD_MEMBERS,
      actions.ADD_TEAM_BOARD_MEMBER_REQUEST,
      actions.UPDATE_TEAM_BOARD_MEMBER_REQUEST,
      actions.DELETE_TEAM_BOARD_MEMBER_REQUEST,
      actions.LIST_TEAM_REFERENCES_REQUEST,
      actions.HIDE_TEAM_REFERENCES,
      actions.ADD_TEAM_REFERENCE_REQUEST,
      actions.UPDATE_TEAM_REFERENCE_REQUEST,
      actions.DELETE_TEAM_REFERENCE_REQUEST,
      actions.LIST_FINANCIALS_INVENTORY_LOCATIONS_REQUEST,
      actions.HIDE_FINANCIALS_INVENTORY_LOCATIONS,
      actions.ADD_FINANCIALS_INVENTORY_LOCATION_REQUEST,
      actions.UPDATE_FINANCIALS_INVENTORY_LOCATION_REQUEST,
      actions.DELETE_FINANCIALS_INVENTORY_LOCATION_REQUEST,
      actions.LIST_FINANCIALS_BANK_ACCOUNTS_REQUEST,
      actions.HIDE_FINANCIALS_BANK_ACCOUNTS,
      actions.ADD_FINANCIALS_BANK_ACCOUNT_REQUEST,
      actions.UPDATE_FINANCIALS_BANK_ACCOUNT_REQUEST,
      actions.DELETE_FINANCIALS_BANK_ACCOUNT_REQUEST,
      actions.LOAD_VENDORS_REQUEST,
      actions.UPDATE_TEAM_ADVISORS_REQUEST,
      actions.UPDATE_FINANCIALS_VENDORS_REQUEST,
      actions.GET_FINANCIALS_CODAT_LINK_REQUEST,
      actions.CLIENT_INFO_RELOAD_REQUEST,
      actions.REFRESH_AUTO_REPORTING_REQUEST,
    ],
  ),
  dueDiligenceStats(state: IDueDiligenceStats = null, action: IAction): IDueDiligenceStats {
    switch (action.type) {
      case actions.GET_STATS_SUCCESS:
        return action.data as IDueDiligenceStats
      default:
        return state
    }
  },
  prospects(state: IClientInfo[] = [], action: IAction): IClientInfo[] {
    switch (action.type) {
      case actions.LIST_PROSPECTS_SUCCESS:
        return action.data as IClientInfo[]
      default:
        return state
    }
  },
  dueDiligenceAggregation: createLoadingDataReducer<IDueDiligenceAggregation>([
    actions.LIST_SUCCESS,
  ]),
  dueDiligenceInfo(state: IDueDiligence = null, action: IAction): IDueDiligence {
    switch (action.type) {
      case actions.SHOW_SUCCESS:
      case actions.CLIENT_INFO_SUCCESS:
      case actions.CLIENT_INFO_RELOAD_SUCCESS:
        return action.data as IDueDiligence
      case actions.UPDATE_SUCCESS: {
        const data = action.data as IDueDiligence
        let newState = {
          ...state,
        }
        if (data.salesforceDDInfo) {
          newState.salesforceDDInfo = {
            ...state.salesforceDDInfo,
            ...data.salesforceDDInfo,
          }
        } else if (data.ddInfo) {
          newState.ddInfo = {
            ...state.ddInfo,
            ...data.ddInfo,
          }
        } else {
          newState = {
            ...data,
          }
        }
        return newState
      }
      case actions.GET_FINANCIALS_CODAT_LINK_SUCCESS: {
        const data = action.data as Partial<IDueDiligence>
        return {
          ...state,
          ...data,
        }
      }
      case actions.REFRESH_AUTO_REPORTING_SUCCESS:
      case UPDATE_DUE_DILIGENCE: {
        const data = action.data as IDueDiligence
        if (!state || state?.id !== data.id) {
          return state
        }

        return {
          ...state,
          ...data,
        }
      }
      case actions.HIDE:
        return null
      default:
        return state
    }
  },
  dueDiligenceReporting: createLoadingDataReducer<{
    data: IDueDiligenceReporting[]
  }>([actions.SHOW_REPORTING_REQUEST], [actions.UPDATE_REPORTING_REQUEST], true),
  dueDiligenceReportingFlows: createLoadingDataReducer<IDueDiligenceReportingFlowsResponse>(
    [actions.SHOW_DOCUMENTS_REQUEST],
    [
      actions.UPDATE_DOCUMENT_REQUEST,
      actions.UNPROCESS_DOCUMENT_REQUEST,
      actions.DELETE_DOCUMENTS_REQUEST,
      actions.CREATE_DOCUMENTS_REQUEST,
    ],
    true,
    [actions.HIDE_DOCUMENTS],
  ),
  aliasMapping: createLoadingDataReducer<{ data: IAlias[] }>(
    [actions.LIST_ALIAS_MAPPING_REQUEST],
    [],
    false,
    [actions.HIDE_ALIAS_MAPPING],
  ),
  dueDiligenceDocumentRequestsTypes(
    state: IDueDiligenceDocumentRequestType[] = [],
    action: IAction & { id: string },
  ): IDueDiligenceDocumentRequestType[] {
    switch (action.type) {
      case actions.SHOW_DOCUMENT_REQUESTS_TYPES_SUCCESS:
      case actions.LIST_DOCUMENT_REQUEST_TYPES_SUCCESS:
        return action.data as IDueDiligenceDocumentRequestType[]
      case actions.HIDE_DOCUMENT_REQUESTS_TYPES:
        return []
      case actions.CREATE_DOCUMENT_REQUEST_TYPE_SUCCESS: {
        const data = action.data as IDueDiligenceDocumentRequestType
        return [...state, data]
      }
      case actions.UPDATE_DOCUMENT_REQUEST_TYPE_SUCCESS: {
        const data = action.data as IDueDiligenceDocumentRequestType
        return state.map((item) => (item?.id === data?.id ? data : item))
      }
      case actions.DELETE_DOCUMENT_REQUEST_TYPE_SUCCESS:
        return state.filter((item) => item?.id !== action?.id)
      default:
        return state
    }
  },
  dataRoomFolders: createLoadingDataReducer<{
    data: IDueDiligenceDataRoomFolder[]
  }>([actions.LIST_DATAROOM_FOLDERS_REQUEST], [actions.LIST_DATAROOM_FOLDERS_SUCCESS]),

  dueDiligenceDocumentRequests: createLoadingDataReducer<{
    data: IDueDiligenceDocumentRequest[]
  }>(
    [actions.SHOW_DOCUMENT_REQUESTS_REQUEST],
    [
      actions.CREATE_DOCUMENT_REQUESTS_REQUEST,
      actions.UPLOAD_DOCUMENT_REQUESTS_REQUEST,
      actions.UPDATE_DOCUMENT_REQUESTS_REQUEST,
      actions.UPDATE_DOCUMENTS_REQUESTS_REQUEST,
      actions.DELETE_DOCUMENT_REQUESTS_REQUEST,
      actions.DELETE_DOCUMENTS_REQUESTS_REQUEST,
      actions.CREATE_DOCUMENT_REQUESTS_COMMENT_REQUEST,
      actions.UPDATE_DOCUMENT_REQUESTS_COMMENT_REQUEST,
      actions.DELETE_DOCUMENT_REQUESTS_COMMENT_REQUEST,
    ],
    true,
    [actions.HIDE_DOCUMENT_REQUESTS],
    false,
    (state, action: IAction) => {
      // Handle document type creation
      if (action.type === actions.CREATE_DOCUMENT_REQUESTS_SUCCESS) {
        const data = action.data as IDueDiligenceDocumentRequest
        const currentData = state.data.data || []
        return {
          ...state,
          data: {
            ...state.data,
            data: [...currentData, { ...data }],
          },
        }
      }

      // Handle document request updates
      if (action.type === actions.UPDATE_DOCUMENT_REQUESTS_SUCCESS) {
        const data = action.data as IDueDiligenceDocumentRequest
        return {
          ...state,
          data: {
            ...state.data,
            data: (state.data.data || []).map((item) => (item.id === data.id ? data : item)),
          },
        }
      }

      // Handle comment creation, updates and deletions
      if (action.type === actions.CREATE_DOCUMENT_REQUESTS_COMMENT_SUCCESS) {
        const data = action.data as IDueDiligenceDocumentRequestComment & {
          ddDocumentRequestId: string
        }
        return {
          ...state,
          data: {
            ...state.data,
            data: (state.data.data || []).map((item) =>
              item.id === data.ddDocumentRequestId
                ? {
                    ...item,
                    comments: item.comments.find((comment) => comment.id === data.id)
                      ? item.comments.map((comment) => (comment.id === data.id ? data : comment))
                      : [...item.comments, data],
                  }
                : item,
            ),
          },
        }
      }

      if (action.type === actions.UPDATE_DOCUMENT_REQUESTS_COMMENT_SUCCESS) {
        const data = action.data as IDueDiligenceDocumentRequestComment & {
          ddDocumentRequestId: string
        }
        return {
          ...state,
          data: {
            ...state.data,
            data: (state.data.data || []).map((item) =>
              item.id === data.ddDocumentRequestId
                ? {
                    ...item,
                    comments: item.comments.map((comment) =>
                      comment.id === data.id ? data : comment,
                    ),
                  }
                : item,
            ),
          },
        }
      }

      if (action.type === actions.DELETE_DOCUMENT_REQUESTS_COMMENT_SUCCESS) {
        const data = action.data as IDueDiligenceDocumentRequestComment & {
          ddDocumentRequestId: string
        }
        return {
          ...state,
          data: {
            ...state.data,
            data: (state.data.data || []).map((item) =>
              item.id === data.ddDocumentRequestId
                ? {
                    ...item,
                    comments: item.comments.filter((comment) => comment.id !== data.id),
                  }
                : item,
            ),
          },
        }
      }

      if (action.type === actions.UPLOAD_DOCUMENT_REQUESTS_SUCCESS) {
        const data = action.data as IDueDiligenceDocumentRequest
        return {
          ...state,
          data: {
            ...state.data,
            data: (state.data.data || []).map((item) => (item.id === data.id ? data : item)),
          },
        }
      }

      return state
    },
  ),
  dueDiligenceCompanyInfo(
    state: IDueDiligenceCompanyInfo = null,
    action: IAction,
  ): IDueDiligenceCompanyInfo {
    switch (action.type) {
      case actions.COMPANY_INFO_SUCCESS:
      case actions.UPDATE_COMPANY_INFO_SUCCESS:
        return action.data as IDueDiligenceCompanyInfo
      default:
        return state
    }
  },
  dueDiligenceTeamContacts: createLoadingDataReducer<{
    data: IDueDiligenceContact[]
    totalInvitedUsers?: number
    clientId?: string
  }>(
    [actions.LIST_TEAM_CONTACTS_REQUEST],
    [
      actions.ADD_TEAM_CONTACT_REQUEST,
      actions.UPDATE_TEAM_CONTACT_REQUEST,
      actions.DELETE_TEAM_CONTACT_REQUEST,
    ],
    true,
    [actions.HIDE_TEAM_CONTACTS],
  ),
  dueDiligenceTeamExecutives: createLoadingDataReducer<{
    data: IDueDiligenceExecutive[]
  }>(
    [actions.LIST_TEAM_EXECUTIVES_REQUEST],
    [
      actions.ADD_TEAM_EXECUTIVE_REQUEST,
      actions.UPDATE_TEAM_EXECUTIVE_REQUEST,
      actions.DELETE_TEAM_EXECUTIVE_REQUEST,
    ],
    true,
    [actions.HIDE_TEAM_EXECUTIVES],
  ),
  dueDiligenceTeamBoardMembers: createLoadingDataReducer<{
    data: IDueDiligenceBoardMember[]
  }>(
    [actions.LIST_TEAM_BOARD_MEMBERS_REQUEST],
    [
      actions.ADD_TEAM_BOARD_MEMBER_REQUEST,
      actions.UPDATE_TEAM_BOARD_MEMBER_REQUEST,
      actions.DELETE_TEAM_BOARD_MEMBER_REQUEST,
    ],
    true,
    [actions.HIDE_TEAM_BOARD_MEMBERS],
  ),
  dueDiligenceTeamReferences: createLoadingDataReducer<{
    data: IDueDiligenceReference[]
  }>(
    [actions.LIST_TEAM_REFERENCES_REQUEST],
    [
      actions.ADD_TEAM_REFERENCE_REQUEST,
      actions.UPDATE_TEAM_REFERENCE_REQUEST,
      actions.DELETE_TEAM_REFERENCE_REQUEST,
    ],
    true,
    [actions.HIDE_TEAM_REFERENCES],
  ),
  dueDiligenceFinancialsInventoryLocations: createLoadingDataReducer<{
    data: IDueDiligenceInventoryLocation[]
  }>(
    [actions.LIST_FINANCIALS_INVENTORY_LOCATIONS_REQUEST],
    [
      actions.ADD_FINANCIALS_INVENTORY_LOCATION_REQUEST,
      actions.UPDATE_FINANCIALS_INVENTORY_LOCATION_REQUEST,
      actions.DELETE_FINANCIALS_INVENTORY_LOCATION_REQUEST,
    ],
    true,
    [actions.HIDE_FINANCIALS_INVENTORY_LOCATIONS],
  ),
  dueDiligenceFinancialsBankAccounts: createLoadingDataReducer<{
    data: IDueDiligenceBankAccount[]
  }>(
    [actions.LIST_FINANCIALS_BANK_ACCOUNTS_REQUEST],
    [
      actions.ADD_FINANCIALS_BANK_ACCOUNT_REQUEST,
      actions.UPDATE_FINANCIALS_BANK_ACCOUNT_REQUEST,
      actions.DELETE_FINANCIALS_BANK_ACCOUNT_REQUEST,
    ],
    true,
    [actions.HIDE_FINANCIALS_BANK_ACCOUNTS],
  ),
  refreshCount: (state = 0, action: IAction) => {
    switch (action.type) {
      case actions.REFRESH_COUNT:
        return state + 1
    }

    return state
  },
  historicalLineTurnData: createLoadingDataReducer<IHistoricalLineTurnData>([
    actions.GET_HISTORICAL_LINE_TURN_REQUEST,
  ]),
  historicalLineTurnOptionsData: createLoadingDataReducer<IHistoricalLineTurnOptionsData>([
    actions.GET_HISTORICAL_LINE_TURN_OPTIONS_REQUEST,
  ]),
  dueDiligenceDefaultNotesOptions: createLoadingDataReducer<IDefaultNoteOptionsData>([
    actions.GET_DEFAULT_NOTES_OPTIONS_REQUEST,
  ]),
  dueDiligenceDefaultNotes: createLoadingDataReducer<{ data: IDefaultNote[] }>(
    [actions.LIST_DEFAULT_NOTES_REQUEST],
    [
      actions.CREATE_DEFAULT_NOTE_REQUEST,
      actions.UPDATE_DEFAULT_NOTE_REQUEST,
      actions.DELETE_DEFAULT_NOTE_REQUEST,
    ],
  ),
  dueDiligenceDefaultCommentary: (
    state: ILoadingData<IDefaultCommentarySection[]> = {
      isLoading: true,
      isSaving: false,
      isSaved: false,
      data: [],
    },
    action: IAction,
  ): ILoadingData<IDefaultCommentarySection[]> => {
    if (actions.LIST_DEFAULT_COMMENTARY_REQUEST === action.type) {
      return {
        ...state,
        isLoading: true,
      }
    }

    if (
      [
        actions.CREATE_DEFAULT_COMMENTARY_REQUEST,
        actions.CREATE_DEFAULT_COMMENTARY_SECTION_REQUEST,
        actions.CREATE_DEFAULT_COMMENTARY_FIELD_REQUEST,
        actions.UPDATE_DEFAULT_COMMENTARY_REQUEST,
        actions.UPDATE_DEFAULT_COMMENTARY_SECTION_REQUEST,
        actions.DELETE_DEFAULT_COMMENTARY_REQUEST,
        actions.DELETE_DEFAULT_COMMENTARY_SECTION_REQUEST,
        actions.REORDER_DEFAULT_COMMENTARY_REQUEST,
      ].includes(action.type)
    ) {
      return {
        ...state,
        isSaving: true,
        isSaved: false,
      }
    }

    if (
      [
        actions.LIST_DEFAULT_COMMENTARY_FAILURE,
        actions.CREATE_DEFAULT_COMMENTARY_FAILURE,
        actions.CREATE_DEFAULT_COMMENTARY_SECTION_FAILURE,
        actions.CREATE_DEFAULT_COMMENTARY_FIELD_FAILURE,
        actions.UPDATE_DEFAULT_COMMENTARY_FAILURE,
        actions.UPDATE_DEFAULT_COMMENTARY_SECTION_FAILURE,
        actions.DELETE_DEFAULT_COMMENTARY_FAILURE,
        actions.DELETE_DEFAULT_COMMENTARY_SECTION_FAILURE,
        actions.REORDER_DEFAULT_COMMENTARY_FAILURE,
      ].includes(action.type)
    ) {
      return {
        ...state,
        isLoading:
          action.type === actions.LIST_DEFAULT_COMMENTARY_FAILURE ? false : state.isLoading,
        isSaving: false,
      }
    }

    switch (action.type) {
      case actions.LIST_DEFAULT_COMMENTARY_SUCCESS: {
        const payload = action.data as { data: IDefaultCommentarySection[] }
        return {
          ...state,
          isLoading: false,
          data: payload.data,
        }
      }

      case actions.CREATE_DEFAULT_COMMENTARY_FIELD_SUCCESS: {
        // Sections store their fields under `commentaries: ICommentary[]`,
        // so the success payload is shaped like an ICommentary row.
        const newField = action.data as ICommentary
        const sectionId = newField.sectionId

        const updatedData = state.data.map((section) => {
          if (section.id === sectionId) {
            const updatedCommentaries = [...(section.commentaries || []), newField]
            return {
              ...section,
              commentaries: updatedCommentaries,
            }
          }
          return section
        })

        return {
          ...state,
          isSaving: false,
          isSaved: true,
          data: updatedData,
        }
      }

      case actions.CREATE_DEFAULT_COMMENTARY_SECTION_SUCCESS: {
        const newSection = action.data as IDefaultCommentarySection
        const updatedData = [...state.data, newSection]

        return {
          ...state,
          data: updatedData,
          isSaving: false,
          isSaved: true,
        }
      }

      case actions.UPDATE_DEFAULT_COMMENTARY_SUCCESS: {
        const updatedField = action.data as ICommentary
        const updatedData = state.data.map((section) => {
          if (!section.commentaries) return section

          const fieldIndex = section.commentaries.findIndex((field) => field.id === updatedField.id)

          if (fieldIndex !== -1) {
            const updatedCommentaries = [...section.commentaries]

            updatedCommentaries[fieldIndex] = {
              ...updatedCommentaries[fieldIndex],
              ...updatedField,
              note: updatedField.note || updatedCommentaries[fieldIndex].note,
            }

            return {
              ...section,
              commentaries: updatedCommentaries,
            }
          }

          return section
        })

        return {
          ...state,
          isSaving: false,
          isSaved: true,
          data: updatedData,
        }
      }

      case actions.UPDATE_DEFAULT_COMMENTARY_SECTION_SUCCESS: {
        const updatedSection = action.data as IDefaultCommentarySection
        const updatedData = state.data.map((section) =>
          section.id === updatedSection.id ? { ...section, ...updatedSection } : section,
        )

        return {
          ...state,
          data: updatedData,
          isSaving: false,
          isSaved: true,
        }
      }

      case actions.DELETE_DEFAULT_COMMENTARY_SUCCESS: {
        const deletedFieldId = (action.data as { id?: string } | undefined)?.id

        const updatedData = state.data.map((section) => {
          if (!section.commentaries) return section

          return {
            ...section,
            commentaries: section.commentaries.filter((field) => field.id !== deletedFieldId),
          }
        })

        return {
          ...state,
          isSaving: false,
          isSaved: true,
          data: updatedData,
        }
      }

      case actions.DELETE_DEFAULT_COMMENTARY_SECTION_SUCCESS: {
        const deletedId = (action.data as { id?: string } | undefined)?.id

        const updatedData = state.data.filter((section) => section.id !== deletedId)

        return {
          ...state,
          data: updatedData,
          isSaving: false,
          isSaved: true,
        }
      }

      case actions.REORDER_DEFAULT_COMMENTARY_SUCCESS: {
        const { fieldId, newOrder } = action.data as { fieldId: string; newOrder: number }
        const updatedData = [...state.data]

        for (let i = 0; i < updatedData.length; i++) {
          const section = updatedData[i]
          if (section.commentaries) {
            const fieldIndex = section.commentaries.findIndex((field) => field.id === fieldId)
            if (fieldIndex !== -1) {
              const updatedCommentaries = [...section.commentaries]

              const [movedField] = updatedCommentaries.splice(fieldIndex, 1)

              movedField.note = {
                ...movedField.note,
                dragOrder: newOrder,
              }

              updatedCommentaries.splice(newOrder - 1, 0, movedField)

              const commentariesWithNewOrder = updatedCommentaries.map((field, idx) => ({
                ...field,
                note: {
                  ...field.note,
                  dragOrder: idx + 1,
                },
              }))

              updatedData[i] = {
                ...section,
                commentaries: commentariesWithNewOrder,
              }
              break
            }
          }
        }

        return {
          ...state,
          data: updatedData,
          isSaving: false,
          isSaved: true,
        }
      }

      case actions.REORDER_DEFAULT_COMMENTARY_SECTION_SUCCESS: {
        const { sectionId, newOrder, tab } = action.data as {
          sectionId: string
          newOrder: number
          tab: string
        }

        const updatedData = [...state.data]

        const tabSections = updatedData.filter((section) => section.tab === tab)

        if (tabSections.length > 0) {
          const sectionIndex = updatedData.findIndex((section) => section.id === sectionId)

          if (sectionIndex !== -1) {
            const [movedSection] = updatedData.splice(sectionIndex, 1)

            const tabSectionIds = tabSections.map((section) => section.id)
            const tabSectionIndexes = tabSectionIds
              .map((id) => updatedData.findIndex((section) => section.id === id))
              .filter((idx) => idx !== -1)
              .sort((a, b) => a - b)

            const insertAtIndex =
              newOrder <= 1
                ? tabSectionIndexes[0] || 0
                : tabSectionIndexes[newOrder - 1] || updatedData.length

            movedSection.order = newOrder

            updatedData.splice(insertAtIndex, 0, movedSection)

            const updatedTabSections = updatedData.filter((section) => section.tab === tab)
            updatedTabSections.forEach((section, idx) => {
              const sectionIndex = updatedData.findIndex((s) => s.id === section.id)
              if (sectionIndex !== -1) {
                updatedData[sectionIndex] = {
                  ...updatedData[sectionIndex],
                  order: idx + 1,
                }
              }
            })
          }
        }

        return {
          ...state,
          data: updatedData,
          isSaving: false,
          isSaved: true,
        }
      }

      default:
        return state
    }
  },
  tagOrder: (
    state: ILoadingData<{ data: string[] }> = {
      isLoading: false,
      isSaving: false,
      isSaved: false,
      data: { data: [] },
    },
    action: IAction,
  ): ILoadingData<{ data: string[] }> => {
    switch (action.type) {
      case actions.GET_TAG_ORDER_REQUEST:
        return {
          ...state,
          isLoading: true,
        }
      case actions.GET_TAG_ORDER_SUCCESS:
        return {
          ...state,
          isLoading: false,
          data: { data: action.data as string[] },
        }
      case actions.GET_TAG_ORDER_FAILURE:
        return {
          ...state,
          isLoading: false,
        }
      default:
        return state
    }
  },
})
